
















































































declare var window: any;
import { Component, Vue } from 'vue-property-decorator';

import RegistrationCard from './Registration/Card.vue';
import CardHeader from './Registration/Header.vue';
import CandidatePortalLogo from './CandidatePortalLogo.vue';
import { ATSJobListParams } from '../models/jobs/atsjoblistparams';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import { vxm } from '@/store.vuex';
import router from '@/router';
@Component({
  name: 'AppReferral',
  components: {
    RegistrationCard,
    CardHeader,
    CandidatePortalLogo,
    VueGoogleAutocomplete,
  },
})
export default class AppReferral extends Vue {
  private jobListParams: ATSJobListParams = new ATSJobListParams();
  private isButtonEnableJobsNearby: Boolean = false;
  get Company() {
    return vxm.referrals.ReferralWrapper.companyInfo.companyName;
  }
  get candidatePortalApplicationName() {
    return vxm.utility.CandidatePortalApplicationName;
  }
  get isMobileDevice() {
    return vxm.utility.isMobileDevice;
  }
  get Referrer() {
    return vxm.referrals.ReferralWrapper.referredUserName;
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get isAnonymousFindJobsEnabled() {
    return !vxm.configs.getGlobalConfigBooelanValue('DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN')
  }

  get isDisableReferralBonusInfo() {
    return vxm.configs.getGlobalConfigBooelanValue('DISABLE_REFERRAL_BONUS_INFO_IN_REFERRAL_PAGE')
  }

  getAddressData(addressData, placeResultData, id) {
    console.log(addressData);
    this.jobListParams.geoLocation.latLong.latitude = addressData.latitude;
    this.jobListParams.geoLocation.latLong.longitude = addressData.longitude;
    this.jobListParams.geoLocation.requestPref = 'LATLONG';
    this.isButtonEnableJobsNearby = true;
    console.log('JobList', this.jobListParams);
  }
  filterJobs() {
    this.jobListParams.resultPage = 1;
    this.jobListParams.resultSize = 5;
    this.jobListParams.geoLocation.requestPref = 'LATLONG';
    this.jobListParams.filter.radius = 5000;
    this.jobListParams.sortCriteria.sortField = '05';
    vxm.jobs.reloadJobs(this.jobListParams).then(() => {
      router.push({ name: 'Findjobs' });
    });
  }

  onReferralAction() {
    if (this.isLoggedIn) {
      this.$router.push({ name: 'ReferAFriend' });
    } else {
      let routeName = vxm.utility.useLoginSignupV2
        ? 'LoginUniversalEntryPoint'
        : 'Signup';

      this.$router.push({ name: routeName });
    }
  }
}
